import { AxiosResponse } from 'axios';
import ApiService from './api.service';
import { DispensaryEndpoint } from './api.endpoints';

class DispensaryService extends ApiService {
  async fetchByState(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.get(DispensaryEndpoint.FETCH_BY_STATE, payload);
    return response;
  }

  async addDispensariesToBrand(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(DispensaryEndpoint.ADD_DISPENSARY_TO_BRAND, payload);
    return response;
  }

  async fetchDispensariesByBrand(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.get(DispensaryEndpoint.FETCH_BY_BRAND, payload);
    return response;
  }

  async removeDispensaryFromBrand(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.delete(DispensaryEndpoint.REMOVE_DISPENSARY_FROM_BRAND, payload);
    return response;
  }
}

export default DispensaryService;
